type User = {
    firstName?: string,
    lastName?: string,
    email?: string,
    picture?: string,
};

export const getUserLabel = (user: User): string => {
    const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
    return name || user.email || '';
};

